import { Menu, MenuItem, MenuSelectEvent } from "@progress/kendo-react-layout";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import './menuheader.css';
import { Button } from "@progress/kendo-react-buttons";
import { logout, setPlanoHeaderExpanded, setSectionHeaderExpanded } from "../redux/features/appStateSlice";
import sizeConfigs from "../configs/sizeConfigs";
import { useAppSelector } from "../redux/store";

interface MenuHeaderProps {
    children: any;
}

export default function MenuHeader(props: MenuHeaderProps) {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const planoHeaderExpanded = useAppSelector(state => state.appState.planoHeaderExpanded);
    const sectionHeaderExpanded = useAppSelector(state => state.appState.sectionHeaderExpanded);

    const onSelect = async (event: MenuSelectEvent) => {
        if (event.item.data?.type === "logout") {
            navigate('/');
            dispatch(logout());
        }
        else if (event.item.data?.type === "icone") {
            if (location.pathname.includes("section"))
                dispatch(setSectionHeaderExpanded(!sectionHeaderExpanded))
            else
                dispatch(setPlanoHeaderExpanded(!planoHeaderExpanded));
        }
    };

    const customLinkRender = () => {
        return (<div className="k-cursor-pointer k-d-flex k-align-items-center k-h-full app-infos" style={{ padding: '6px 12px' }}>
            <span className="k-icon k-font-icon k-i-menu k-icon-lg menu-text" />
            {process.env.REACT_APP_ENV === "DEV" && (<Button className="environment-button" disabled>
                {process.env.REACT_APP_ENV}
            </Button>)}
        </div>);
    };

    return (<><Menu onSelect={onSelect} openOnClick={true} className="k-d-flex k-h-full k-cursor-pointer" style={{
        position: "fixed",
        top: "0", width: "100%", boxShadow: "0 0 10px rgb(0 0 0)", zIndex: '10', height: sizeConfigs.topbar.height, backgroundColor: process.env.REACT_APP_COLOR
    }}>
        <MenuItem data={{ type: "icone" }} linkRender={customLinkRender} />
        <MenuItem url={"/planogramme"} text="Planogramme" cssClass="menu-text" />
        <MenuItem url={"/section"} text="Sections" cssClass="menu-text" />
        <MenuItem text="Mon compte" cssClass={`header-menu-item k-text-center`} cssStyle={{ zIndex: 2147483647, position: 'absolute', right: 0, padding: '6px 12px', height: '100%' }}>
            <MenuItem text="Compte" icon="user" url="/account" data={{ type: "account" }} cssClass="child-menu-item account-menu"></MenuItem>
            <MenuItem text="Déconnexion" icon="logout" url="/" data={{ type: "logout" }} cssClass="child-menu-item account-menu"></MenuItem>
        </MenuItem>
    </Menu>{props.children}</>)
}